import { SNOOZE_STATUSES } from "models";
import { enumToDropdownOptions } from "utils/common";

import type { TFunction } from "i18next";

export const getSnoozeStatusOptions = (t: TFunction) => ({
  snoozeStatusOptions: enumToDropdownOptions({ enumObj: SNOOZE_STATUSES, t, keysToExclude: ["Deleted"] })
});
